import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import type { Observable } from 'rxjs'

import { environment } from '@environment/environment'
import type { ServiceResponse } from '@/app/domain/response/service-response'
import type { LoginCommandRequest } from '@/app/domain/requests/authentication/command/login-command.request'
import type { RefreshTokenCommandRequest } from '@/app/domain/requests/authentication/command/refresh-token-command.request'
import type { LoginCommandResponse } from '@/app/domain/response/authentication/command/login-command.response'
import type { RefreshTokenCommandResponse } from '@/app/domain/response/authentication/command/refresh-token-command.response'
import type { RevokeTokenCommandResponse } from '@/app/domain/response/authentication/command/revoke-token-command.response'

/** Mirrors Automation.Api/Endpoints/AuthEndpoints.cs — anonymous, no bearer token required. */
@Injectable({ providedIn: 'root' })
export class AuthApiService {
  private readonly http = inject(HttpClient)
  private readonly baseUrl = `${environment.apiUrl}/auth`

  login(request: LoginCommandRequest): Observable<ServiceResponse<LoginCommandResponse>> {
    return this.http.post<ServiceResponse<LoginCommandResponse>>(`${this.baseUrl}/login`, request)
  }

  refresh(request: RefreshTokenCommandRequest): Observable<ServiceResponse<RefreshTokenCommandResponse>> {
    return this.http.post<ServiceResponse<RefreshTokenCommandResponse>>(`${this.baseUrl}/refresh`, request)
  }

  /** Reuses RefreshTokenCommandRequest — the API has no separate RevokeTokenCommandRequest class. */
  revoke(request: RefreshTokenCommandRequest): Observable<ServiceResponse<RevokeTokenCommandResponse>> {
    return this.http.post<ServiceResponse<RevokeTokenCommandResponse>>(`${this.baseUrl}/revoke`, request)
  }
}
